import { SearchQuery } from "shared/data/reducers/types/storage";
import { getFlightCombinationsTree } from "shared/gol-api/flightSearch";
import { isTrue } from "shared/lib/functions";
import FlightOffer from "shared/types/flightOffer";

const filterBaggageAndPrice = (searchQuery: SearchQuery) => (
  flightOffer: FlightOffer
) => {
  let brands = flightOffer.FlightCombinations;

  // Filter out flights without baggage (where Quantity = 0)
  if (isTrue(searchQuery.baggage)) {
    brands = brands.filter(
      (brand) => Number(brand.PricingDetail.BaggageLimit.Quantity) !== 0
    );
  }

  // Filter out flights based on price
  if (searchQuery.lowestPrice && searchQuery.highestPrice) {
    brands = brands.filter((brand) => {
      const fullPrice = Number(
        searchQuery.currency
          ? brand.AlternativeCurrencyPricingDetail.FlightPricing.FlightPrice
              .FullPrice
          : brand.PricingDetail.FlightPricing.FlightPrice.FullPrice
      );
      return !(
        fullPrice < Number(searchQuery.lowestPrice) ||
        fullPrice > Number(searchQuery.highestPrice)
      );
    });
  }

  // Edit FlightCombinations if any of above filters changed the original data
  if (brands.length !== flightOffer.FlightCombinations.length) {
    return {
      ...flightOffer,
      FlightCombinations: brands,
      CurrentCombinations: getFlightCombinationsTree(brands),
    };
  }

  return flightOffer;
};

export default filterBaggageAndPrice;
